import ReactDOM from "react-dom";
import {Game} from "./Game";
import {useState} from "react";

const app_div = document.getElementById('root');

function App(){
    const [game, setGame] = useState<JSX.Element>(null);
    const [showGameSelector, setShowGameSelector] = useState<boolean>(true);
    const [proportionDictionary, setProportionDictionary] = useState<number>(7);
    const [aiRandomness, setAIRandomness] = useState<number>(6);
    const [gameCount, setGameCount] = useState<number>(0);

    let gameSelector = null;
    if(showGameSelector){
        gameSelector = <NewGameSelector
            setGame={setGame}
            setShowGameSelector={setShowGameSelector}
            proportionDictionary= {proportionDictionary}
            setProportionDictionary= {setProportionDictionary}
            aiRandomness= {aiRandomness}
            setAIRandomness= {setAIRandomness}
            gameCount = {gameCount}
            setGameCount = {setGameCount}
        />;
    }

    return(<>
        {gameSelector}
        {game}
    </>);

}

function NewGameSelector(props: {
    setGame: (x: JSX.Element) => void;
    setShowGameSelector: (x: boolean) => void;
    proportionDictionary: number;
    setProportionDictionary: (x: number) => void;
    aiRandomness: number;
    setAIRandomness: (x: number) => void;
    gameCount: number;
    setGameCount: (x: number) => void;
}){

    // Can change log scale to control shape of curve using following equation:
    // aiRandomness = log(1 + x*(n-1))/log(n) when x, the user input, ranges between 0 and 1
    const logBase: number = 10000;
    const processedAIRandomness = Math.log(1 + (logBase - 1)*props.aiRandomness/100) / Math.log(logBase);

    return(
        <dialog open>
            <div className="new-game">
                <div className="grid">
                    <label htmlFor="proportion-dictionary">AI's proportion of dictionary:</label>
                    <input type="number"
                           name="proportion-dictionary"
                           value={props.proportionDictionary}
                           onInput={(e) => {
                               props.setProportionDictionary(parseInt(e.currentTarget.value));
                           }}
                           min={1}
                           max={100}/>
                    <label htmlFor="randomness">Level of randomness in AI:</label>
                    <input type="number"
                           name="randomness"
                           value={props.aiRandomness}
                           onInput={(e) => {
                               props.setAIRandomness(parseInt(e.currentTarget.value));
                           }}
                           min={0}
                           max={100}/>
                </div>
                <details>
                    <ul>
                        <li>
                            "AI's proportion of dictionary" controls what percent of the total AI dictionary
                            the AI can form words with. At 100%, it has access to its entire dictionary -
                            although this dictionary is still less than what the player has access to.</li>
                        <li>
                            <div>
                                "Level of randomness in AI" controls the degree to which the AI picks the optimal move
                            for each of its turns. At 0, it always picks the highest scoring move it can do using the
                            dictionary it has access to. At 1, it picks from its available moves at random.
                            </div>
                            <div>
                                Note that "Level of randomness in AI" is now mapped on a log scale.
                                Your current setting is equivalent to {(100*processedAIRandomness).toFixed(1)}% on the previous scale.
                            </div>
                        </li>

                    </ul>
                </details>
                <div className="selection-buttons">
                    <button onClick={(e) => {
                        props.setGame(null); // trying to reset the state
                        props.setGame(<Game
                            key={props.gameCount}
                            proportionDictionary={props.proportionDictionary/100}
                            aiRandomness={processedAIRandomness}
                            endGame={() => {
                                props.setShowGameSelector(true);
                            }}/>);
                        props.setShowGameSelector(false);
                        props.setGameCount(props.gameCount + 1);
                    }}>New Game</button>
                    {props.gameCount > 0 && <button onClick={(e) => {
                        props.setShowGameSelector(false);
                    }}>Cancel</button>}
                </div>
            </div>
        </dialog>
    );

}

ReactDOM.render(<App />, app_div);